// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const STAKING_REQUEST_EVENT = '0x3::validator::StakingRequestEvent';
export const UNSTAKING_REQUEST_EVENT = '0x3::validator::UnstakingRequestEvent';

export const DELEGATED_STAKES_QUERY_STALE_TIME = 10_000;
export const DELEGATED_STAKES_QUERY_REFETCH_INTERVAL = 30_000;

export const NUM_OF_EPOCH_BEFORE_STAKING_REWARDS_REDEEMABLE = 2;
export const NUM_OF_EPOCH_BEFORE_STAKING_REWARDS_STARTS = 1;
export const MIN_NUMBER_IOTA_TO_STAKE = 1;

export const EFFECTIVE_COMMISSION_TOOLTIP =
    'The share of rewards retained by the validator. This rate includes a protocol-enforced minimum to help maintain network decentralization.';
